import React from "react";
import logo from "../../../assets/white-logo-with-accents.png";
import mosaic from "../../../assets/landing-footer-mosaic.png";
import { UserType } from "../../../data/enums";

interface LandingFooterProps {
  redirect: (path: string) => void;
}

function LandingFooter({ redirect }: LandingFooterProps) {
  return (
    <>
      <div className="landing-footer-desktop">
        <div className="landing-footer-main">
          <img
            className="landing-footer-img"
            src={logo}
            alt="Logo de Mr. Gen"
          />
          <div className="landing-footer-options">
            <p
              onClick={() => redirect(`/signup/?user=${UserType.Nutritionist}`)}
            >
              Para nutricionistas
            </p>
            <p onClick={() => redirect(`/signup/?user=${UserType.Company}`)}>
              Para empresas
            </p>
            <p onClick={() => redirect(`/signup/?user=${UserType.EndUser}`)}>
              Comprar Kit
            </p>
            <p onClick={() => redirect(`/terminos-condiciones-uso-uy`)}>
              Términos y condiciones
            </p>
          </div>
        </div>
        <p className="landing-footer-copyright">
          ®2023 Mr Gen. Todos los derechos reservados.
        </p>
      </div>
      <div className="landing-footer-mobile">
        <p onClick={() => redirect(`/terminos-condiciones-uso-uy`)}>
          Términos y condiciones
        </p>  
        <p className="landing-footer-copyright">
          ®2023 Mr Gen. Todos los derechos reservados.
        </p>
        <img src={mosaic} alt="Mosaico decorativo"/>
      </div>
    </>
  );
}

export default LandingFooter;
